import constants from './constants' 
// private config
const development = {
    endpoints: {
        backend: 'https://boq-mebank.api-r2s-dev.genesysinnoapps.net',
    },
    clientID: constants.GC_CLIENT_ID,
    integrationType: constants.R2S_INTEGRATION_TYPE,
    appName: "Genesys Recording as a Service (R2S) - Dec",
    defaultEnvironment: constants.GC_ENV_AP_SOUTHEAST_2,
    defaultLangTag: constants.GC_LANG_TAG,
    userRole : constants.R2S_USER_ROLE_DEV
}

const production = {
    endpoints: {
        backend: 'https://boq-mebank.api-r2s.genesysinnoapps.com',
    },
    clientID: constants.GC_CLIENT_ID,
    integrationType: constants.R2S_INTEGRATION_TYPE,
    appName: "Genesys Recording as a Service (R2S)",
    defaultEnvironment: constants.GC_ENV_AP_SOUTHEAST_2,
    defaultLangTag: constants.GC_LANG_TAG,
    userRole : constants.R2S_USER_ROLE_PROD
}

const qa = {
    endpoints: {
        backend: 'https://d3ifxn5m8di455.cloudfront.net',
    },
    clientID: constants.GC_CLIENT_ID,
    integrationType: constants.R2S_INTEGRATION_TYPE, 
    defaultEnvironment: constants.GC_ENV_AP_SOUTHEAST_2,
    defaultLangTag: constants.GC_LANG_TAG,
    userRole : constants.R2S_USER_ROLE_TEST
}

const env = process.env.REACT_APP_CUSTOM_ENV.trim()
console.log('env:', env)
let config
switch (env) {
    case constants.REACT_ENV_PROD: config = production; break;
    case constants.REACT_ENV_DEV: config = development; break;
    case constants.REACT_ENV_TEST: config = test; break;
    default: break;
}

export default config
